import axios from "axios";
import { API_URL, dispatchLoading, dispatchError, catchHandler, elseHandler, dispatchToast } from "../../helpers/utils";

const USER_URL = `${API_URL}/quote`;
const limit = 15;

export const ListQuote = (page, is_active, start_date, end_date, time_zone, setIsLoading) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	setIsLoading(true);
	axios
		.get(`${USER_URL}`, { params: { page, is_active, limit, start_date, end_date, time_zone } })
		.then((result) => {
			if (result?.data?.success) {
				setIsLoading(false);
				dispatch({
					type: "QUOTE_LIST_SUCCESS",
					payload: { quoteList: result?.data?.data?.data, quoteCount: result?.data?.data?.count },
				});
				dispatchError(dispatch, "quote", undefined);
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const GetQuoteById = (id) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	axios
		.get(`${USER_URL}`, { params: { id } })
		.then((result) => {
			if (result?.data?.success) {
				dispatch({
					type: "FETCH_QUOTE_DETAILS",
					payload: result?.data?.data?.data.find((ele, i) => ele?._id === id),
				});
				dispatchError(dispatch, "quote", undefined);
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const DeleteQuoteAPI = (id, setIsConfirm, page, is_active, start_date, end_date, time_zone, setIsLoading) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	axios
		.delete(`${USER_URL}`, { data: { id } })
		.then((result) => {
			if (result?.data?.success) {
				// dispatch(PermanentDeleteUser(id));
				setIsConfirm(false);
				dispatch(ListQuote(page, is_active, start_date, end_date, time_zone, setIsLoading));
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const addQuoteAPI = (data, setIsConfirm, page, is_active, start_date, end_date, time_zone, setIsLoading) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	axios
		.post(`${USER_URL}`, { data })
		.then((result) => {
			if (result?.data?.success) {
				// dispatch(PermanentDeleteUser(id));
				setIsConfirm(false);
				dispatch(ListQuote(page, is_active, start_date, end_date, time_zone, setIsLoading));
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const SearchQuote = (search) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	axios
		.get(`${USER_URL}`, { params: { search } })
		.then((result) => {
			if (result?.data?.success) {
				dispatch({ type: "QUOTE_SEARCH_SUCCESS", payload: { list: result?.data?.data?.data, count: result?.data?.data?.count } });
				dispatchError(dispatch, "quote", undefined);
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const toggleQuote = (data) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	axios
		.put(`${USER_URL}/status`, data)
		.then((result) => {
			if (result?.data?.success) {
				// dispatch({ type: "USER_TOGGLE_SUCCESS", payload: result?.data });
				dispatch(ListQuote());
				dispatchToast(dispatch, "success", result?.data?.message);
				dispatchError(dispatch, "quote", undefined);
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const EditQuoteAPI = (data, cancelHandler, params, editParams, setIsLoading) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	axios
		.put(`${USER_URL}`, data)
		.then((result) => {
			if (result?.data?.success) {
				cancelHandler && cancelHandler();
				params && params();
				dispatch(ListQuote2(editParams?.pageId, editParams?.is_active, editParams?.start, editParams?.end, editParams?.localTimeZone));
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const AddQuoteAPI = (data, cancelHandler, params) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);
	axios
		.post(`${USER_URL}`, data)
		.then((result) => {
			if (result?.data?.success) {
				cancelHandler && cancelHandler();
				params && params();
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};

export const ListQuote2 = (page, is_active, start_date, end_date, time_zone) => async (dispatch) => {
	dispatchLoading(dispatch, "quote", true);

	axios
		.get(`${USER_URL}`, { params: { page, is_active, limit, start_date, end_date, time_zone } })
		.then((result) => {
			if (result?.data?.success) {
				dispatch({
					type: "QUOTE_LIST_SUCCESS",
					payload: { quoteList: result?.data?.data?.data, quoteCount: result?.data?.data?.count },
				});
				dispatchError(dispatch, "quote", undefined);
			} else elseHandler(dispatch, "quote", result?.data);
			dispatchLoading(dispatch, "quote", false);
		})
		.catch(catchHandler(dispatch, "quote"));
};
